import {Box, Button, Flex, Text} from '@chakra-ui/react';
import {PieChart} from '../../global/pie-chart';
import {WidgetBoxWrapper} from './widget-box-wrapper';
import {useGeolocation} from '../../../hooks/geolocation';

export interface MarketAvailabilityWidgetProps {
  color: string;
  piecesAvailable: number;
  totalPieces: number;
  averagePiecePrice: number;
  scrollHandler?: () => void;
  handleDrawer?: () => void;
}

export const MarketAvailabilityWidget: React.FC<
  MarketAvailabilityWidgetProps
> = (props) => {
  const {currency, currencyPostfix} = useGeolocation();
  const totalPiecesListed = (props.piecesAvailable / props.totalPieces) * 100;

  return (
    <WidgetBoxWrapper>
      <Flex alignItems="flex-start" padding="16px">
        <Box paddingRight="16px">
          <PieChart
            // eslint-disable-next-line radix
            percentage={`${(totalPiecesListed < 1
              ? 1
              : totalPiecesListed
            ).toFixed(2)}%`}
            color={props.color}
          />
        </Box>
        <Box>
          <Text
            textStyle="h6"
            paddingRight={1}
            lineHeight="1.4"
            color={props.color}
          >
            {props.piecesAvailable} Pieces
            <Text as="span" textStyle="body7" fontSize="12px" pl={1}>
              Available on the marketplace
            </Text>
          </Text>

          <Flex alignItems="center" flexWrap="wrap">
            <Text as="span" textStyle="h7" paddingRight={1}>
              {props.totalPieces}
            </Text>
            <Text as="span" textStyle="body7" fontSize="12px">
              Total Pieces
            </Text>
          </Flex>

          {Number(props.averagePiecePrice) > 0 && (
            <Flex alignItems="start">
              <Text as="span" textStyle="h7" paddingRight={1}>
                {currency}
                {props.averagePiecePrice}
                <Text as="span" fontSize="0.75em" textTransform="uppercase">
                  {currencyPostfix}
                </Text>
              </Text>
              <Text as="span" textStyle="body7" fontSize="12px">
                Average price paid over last 10 transactions
              </Text>
            </Flex>
          )}
        </Box>
      </Flex>
      <Flex w="100%" align="center" justify="center" pb="13px">
        <Button colorScheme="aqua" w="100%" onClick={props.scrollHandler}>
          Buy Pieces
        </Button>
      </Flex>
      <Flex w="100%" align="center" justify="center" pb="13px">
        <Button
          variant="outline"
          colorScheme="aqua"
          w="100%"
          onClick={props.handleDrawer}
        >
          Set up a price alert
        </Button>
      </Flex>
    </WidgetBoxWrapper>
  );
};
